module.exports = __webpack_public_path__ + "static/media/seguranca.db678b95.png";